"use client";

import { c as _c } from "react/compiler-runtime";
import type { ChatMessage } from "../types";
import { FiEdit } from "react-icons/fi";
import Divider from "@/components/ui/divider";
interface AIChatSummaryDividerProps {
  message: ChatMessage;
  onSummaryClick?: (summary: string) => void;
  className?: string;
}
export function AIChatSummaryDivider(t0) {
  const $ = _c(10);
  const {
    message,
    onSummaryClick,
    className
  } = t0;
  const content = typeof message.content === "string" ? message.content : String(message.content || "");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="animate-shimmer absolute inset-0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== content || $[2] !== onSummaryClick) {
    t2 = () => onSummaryClick?.(content);
    $[1] = content;
    $[2] = onSummaryClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center gap-1.5"><span className="text-caption-strong text-foreground-secondary group-hover:text-foreground">Chat summarized</span><FiEdit className="h-3 w-3 text-foreground-muted" /></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="relative my-1 overflow-hidden rounded-md">{t1}<Divider dividerColor="bg-border" className="group relative cursor-pointer transition-colors hover:text-foreground" onClick={t2}>{t3}</Divider></div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== className || $[8] !== t4) {
    t5 = <div className={className}>{t4}</div>;
    $[7] = className;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}